import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ImageCropperComponent, ImageTransform, OutputFormat } from 'ngx-image-cropper';

@Component({
  selector: 'app-profile-cropper',
  templateUrl: './profile-cropper.component.html',
  styleUrls: ['./profile-cropper.component.css']
})
export class ProfileCropperComponent {
  @ViewChild('cropper') cropper: ImageCropperComponent;

  @Input() image: any = '';
  @Input() imageType: OutputFormat = 'png';
  @Input() saving = false;

  @Output() save = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();

  cropperTransform: ImageTransform = {};

  async onSave() {
    if (!this.cropper) { return; }
    try {
      const cropped = await this.cropper.crop('base64');
      if (cropped && cropped.base64) {
        this.save.emit(cropped.base64);
      }
    } catch (err) {
      console.error('Erro ao recortar imagem:', err);
    }
  }

  onCancel() {
    this.cancel.emit();
  }

  imageLoaded() {
    const overlay = document.getElementsByClassName('overlay')[0] as HTMLElement;
    if (!overlay || !overlay.parentElement || !overlay.parentElement.parentElement
      || overlay.parentElement.parentElement.nodeName !== 'IMAGE-CROPPER') {
      return;
    }
    const overlayStyle = overlay.style as CSSStyleDeclaration;
    overlayStyle.outline = 'none';
  }
}
